import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { UserProvider } from './context/UserContext';
import { AdminProvider } from './context/AdminContext';
import AppLayout from './components/Layout/Layout';
import HomePage from './pages/Home/Home';
import ApplyPage from './pages/Apply/Apply';
import SuccessPage from './pages/Success/Success';
import AdminPage from './pages/Admin/Admin';
import { initDatabase } from './db/database';
import { theme } from './theme';

export default function App() {
  const [dbReady, setDbReady] = useState(false);

  useEffect(() => {
    initDatabase()
      .then(() => setDbReady(true))
      .catch((err) => {
        console.error('数据库初始化失败', err);
        setDbReady(true);
      });
  }, []);

  if (!dbReady) {
    return (
      <div className="app-loading">
        <Spin size="large" tip="正在加载..." />
      </div>
    );
  }

  return (
    <ConfigProvider locale={zhCN} theme={theme}>
      <UserProvider>
        <AdminProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<AppLayout />}>
                <Route index element={<HomePage />} />
                <Route path="apply" element={<ApplyPage />} />
                <Route path="success" element={<SuccessPage />} />
                <Route path="admin" element={<AdminPage />} />
                <Route path="records" element={<Navigate to="/admin" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AdminProvider>
      </UserProvider>
    </ConfigProvider>
  );
}
